module.exports = __webpack_public_path__ + "static/media/home9.fc2a1a78.jpg";